// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Practitioner List Unique Styles */
.practitioner-list-custom {
    padding: 2rem;
}

/* Name Filters should be on the same line */
.filters-custom {
    display: flex;
    flex-wrap: wrap;
    gap: 1rem;
    justify-content: space-between;
}

/* Ensure all name fields appear on the same line */
.name-fields-custom {
    display: flex;
    gap: 1rem;
    flex-wrap: nowrap;
    width: 100%; 
}

/* Style the select fields so they appear evenly */
.name-fields-custom select {
    flex-grow: 1; 
    padding: 0.75rem;
    border-radius: var(--radius);
    border: 1px solid var(--clr-grey-6);
    font-size: 1rem;
    color: var(--clr-grey-3);
    min-width: 150px; 
}

/* Add a responsive adjustment to handle small screen sizes */
@media (max-width: 768px) {
    .name-fields-custom {
        flex-wrap: wrap; 
    }

    .name-fields-custom select {
        flex-grow: 1;
        width: 100%; 
    }
}

/* Practitioners Grid */
.practitioner-grid-custom {
    margin-top: 2rem;
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(400px, 1fr)); 
    gap: 1.5rem;
}

/* Practitioner Card */
.practitioner-card-custom {
    background-color: var(--clr-white);
    padding: 1.5rem;
    border-radius: var(--radius);
    box-shadow: var(--light-shadow);
    transition: var(--transition);
    min-height: 200px; 
}

.practitioner-card-custom:hover {
    box-shadow: var(--dark-shadow);
}

/* Responsive Card Content */
.card-content-custom h4 {
    color: var(--clr-primary-5);
    margin-bottom: 0.5rem;
}

.card-content-custom p {
    color: var(--clr-grey-3);
    margin-bottom: 0.25rem;
}

.no-practitioner-card-custom {
    text-align: center;
    background-color: var(--clr-white);
    padding: 2rem;
    border-radius: var(--radius);
    box-shadow: var(--light-shadow);
}

/* Pagination Controls */
.pagination-custom {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 1rem;
}

.pagination-custom button {
    background-color: var(--clr-primary-5);
    color: var(--clr-white);
    padding: 0.5rem 1rem;
    border: none;
    border-radius: var(--radius);
    cursor: pointer;
    margin: 0 0.5rem;
}

.pagination-custom button:hover {
    background-color: var(--clr-primary-4);
    box-shadow: var(--light-shadow);
}

.pagination-custom button[disabled] {
    background-color: var(--clr-grey-5);
    cursor: not-allowed;
}

/* Responsive Design */
@media (max-width: 768px) {
    .practitioner-list-custom {
        padding: 1rem;
    }

    .practitioner-grid-custom {
        grid-template-columns: 1fr; 
    }

    .practitioner-card-custom {
        padding: 1rem;
        margin-bottom: 1rem;
    }

    .card-content-custom h4 {
        font-size: 1rem;
    }

    .card-content-custom p {
        font-size: 0.875rem;
    }

    .no-practitioner-card-custom {
        padding: 1.5rem;
    }

    .filters-custom select {
        padding: 0.5rem;
        font-size: 0.875rem;
    }

    .name-fields-custom {
        flex-direction: column; 
    }
}

@media (max-width: 480px) {
    .practitioner-list-custom {
        padding: 0.5rem;
    }

    .practitioner-card-custom {
        padding: 0.75rem;
    }

    .card-content-custom h4 {
        font-size: 0.875rem;
    }

    .card-content-custom p {
        font-size: 0.75rem;
    }

    .no-practitioner-card-custom {
        padding: 1rem;
    }
}

.registered-card {
    background-color: #e7f9f0; 
    border-left: 5px solid #2e8b57; 
  }
  
  .unregistered-card {
    background-color: #f2f9f6; 
    border-left: 5px solid #a3c9b7; 
  }
  
  
  /* Tabs */
.tabs-custom {
    display: flex;
    gap: 1rem;
    margin-bottom: 1.5rem;
  }
  
  .tabs-custom button {
    padding: 0.6rem 1.2rem;
    background-color: var(--clr-grey-6);
    color: var(--clr-white);
    border: none;
    border-radius: var(--radius);
    font-weight: 700;
    cursor: pointer;
    transition: background-color 0.3s ease;
    font-size: medium;
  }
  
  .tabs-custom button:hover {
    background-color: var(--clr-primary-3);
    color: white;
  }
  
  .tabs-custom .active {
    background-color: var(--clr-primary-5);
    color: white;
  }
  
  /* Admin Section Wrapper */
  .clinic-admins-section {
    margin-top: 1rem;
  }
  
  /* Grid Layout */
  .admin-grid-custom {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
    gap: 1.5rem;
    margin-top: 1rem;
  }
  
  /* Base Admin Card */
  .admin-card-custom {
    background-color: var(--clr-white);
    border-radius: var(--radius);
    box-shadow: var(--shadow-1);
    padding: 1.5rem;
    transition: all 0.3s ease;
    position: relative;
    border: 1px solid var(--grey-200);
  }
  
  /* Hover effect */
  .admin-card-custom:hover {
    box-shadow: var(--shadow-3);
    transform: translateY(-3px);
  }
  
  /* Clinic Owner: Green border + light green background */
  .owner-card {
    border-left: 5px solid #2e7d32; 
    background-color: #e8f5e9;
  }
  
  /* Clinic Admin: Light green background */
    .admin-card {
    border-left: 5px solid #2e7d32;
    background-color: #f1f8f5;
    }

  
  /* Card Heading */
  .admin-card-custom h4 {
    /* font-size: 1.15rem;
    font-weight: 600; */
    color: var(--clr-primary-5);
    margin-bottom: 0.75rem;
  }
  
  /* Card Text */
  .admin-card-custom p {
    margin: 0.4rem 0;
    color: var(--clr-grey-2);
    font-size: 0.95rem;
  }
  
  .admin-card-custom p strong {
    color: var(--clr-grey-1);
  }
  
  /* Responsive styles */
@media (max-width: 768px) {
    .tabs-custom {
      flex-direction: column;
      align-items: stretch;
      gap: 0.5rem;
    }
  
    .tabs-custom button {
      width: 100%;
      text-align: center;
      font-size: 1rem;
    }
  
    .admin-grid-custom {
      grid-template-columns: 1fr; /* Single column on smaller screens */
    }
  
    .admin-card-custom {
      padding: 1rem;
    }
  
    .admin-card-custom h4 {
      font-size: 1rem;
    }
  
    .admin-card-custom p {
      font-size: 0.9rem;
    }
  }
  
  @media (max-width: 480px) {
    .tabs-custom button {
      font-size: 0.95rem;
      padding: 0.5rem 1rem;
    }
  
    .admin-card-custom h4 {
      font-size: 0.95rem;
    }
  
    .admin-card-custom p {
      font-size: 0.85rem;
    }
  }
  
  .skill-section-custom {
    margin-top: 0.5rem;
  }
  
  .skill-tag-container {
    display: flex;
    flex-wrap: wrap;
    gap: 6px;
    margin-top: 4px;
  }
  
  .skill-tag-pill {
    background-color: var(--clr-primary-5);
    color: var(--clr-white);
    padding: 4px 8px;
    border-radius: 12px;
    font-size: 0.85rem;
    font-weight: 500;
    white-space: nowrap;
  }
  `, "",{"version":3,"sources":["webpack://./src/components/staffPortal/practitionerList.css"],"names":[],"mappings":"AAAA,oCAAoC;AACpC;IACI,aAAa;AACjB;;AAEA,4CAA4C;AAC5C;IACI,aAAa;IACb,eAAe;IACf,SAAS;IACT,8BAA8B;AAClC;;AAEA,mDAAmD;AACnD;IACI,aAAa;IACb,SAAS;IACT,iBAAiB;IACjB,WAAW;AACf;;AAEA,kDAAkD;AAClD;IACI,YAAY;IACZ,gBAAgB;IAChB,4BAA4B;IAC5B,mCAAmC;IACnC,eAAe;IACf,wBAAwB;IACxB,gBAAgB;AACpB;;AAEA,6DAA6D;AAC7D;IACI;QACI,eAAe;IACnB;;IAEA;QACI,YAAY;QACZ,WAAW;IACf;AACJ;;AAEA,uBAAuB;AACvB;IACI,gBAAgB;IAChB,aAAa;IACb,2DAA2D;IAC3D,WAAW;AACf;;AAEA,sBAAsB;AACtB;IACI,kCAAkC;IAClC,eAAe;IACf,4BAA4B;IAC5B,+BAA+B;IAC/B,6BAA6B;IAC7B,iBAAiB;AACrB;;AAEA;IACI,8BAA8B;AAClC;;AAEA,4BAA4B;AAC5B;IACI,2BAA2B;IAC3B,qBAAqB;AACzB;;AAEA;IACI,wBAAwB;IACxB,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;IAClB,kCAAkC;IAClC,aAAa;IACb,4BAA4B;IAC5B,+BAA+B;AACnC;;AAEA,wBAAwB;AACxB;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;AACjB;;AAEA;IACI,sCAAsC;IACtC,uBAAuB;IACvB,oBAAoB;IACpB,YAAY;IACZ,4BAA4B;IAC5B,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,sCAAsC;IACtC,+BAA+B;AACnC;;AAEA;IACI,mCAAmC;IACnC,mBAAmB;AACvB;;AAEA,sBAAsB;AACtB;IACI;QACI,aAAa;IACjB;;IAEA;QACI,0BAA0B;IAC9B;;IAEA;QACI,aAAa;QACb,mBAAmB;IACvB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;QACf,mBAAmB;IACvB;;IAEA;QACI,sBAAsB;IAC1B;AACJ;;AAEA;IACI;QACI,eAAe;IACnB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,aAAa;IACjB;AACJ;;AAEA;IACI,yBAAyB;IACzB,8BAA8B;EAChC;;EAEA;IACE,yBAAyB;IACzB,8BAA8B;EAChC;;;EAGA,SAAS;AACX;IACI,aAAa;IACb,SAAS;IACT,qBAAqB;EACvB;;EAEA;IACE,sBAAsB;IACtB,mCAAmC;IACnC,uBAAuB;IACvB,YAAY;IACZ,4BAA4B;IAC5B,gBAAgB;IAChB,eAAe;IACf,sCAAsC;IACtC,iBAAiB;EACnB;;EAEA;IACE,sCAAsC;IACtC,YAAY;EACd;;EAEA;IACE,sCAAsC;IACtC,YAAY;EACd;;EAEA,0BAA0B;EAC1B;IACE,gBAAgB;EAClB;;EAEA,gBAAgB;EAChB;IACE,aAAa;IACb,2DAA2D;IAC3D,WAAW;IACX,gBAAgB;EAClB;;EAEA,oBAAoB;EACpB;IACE,kCAAkC;IAClC,4BAA4B;IAC5B,2BAA2B;IAC3B,eAAe;IACf,yBAAyB;IACzB,kBAAkB;IAClB,iCAAiC;EACnC;;EAEA,iBAAiB;EACjB;IACE,2BAA2B;IAC3B,2BAA2B;EAC7B;;EAEA,wDAAwD;EACxD;IACE,8BAA8B;IAC9B,yBAAyB;EAC3B;;EAEA,yCAAyC;IACvC;IACA,8BAA8B;IAC9B,yBAAyB;IACzB;;;EAGF,iBAAiB;EACjB;IACE;uBACmB;IACnB,2BAA2B;IAC3B,sBAAsB;EACxB;;EAEA,cAAc;EACd;IACE,gBAAgB;IAChB,wBAAwB;IACxB,kBAAkB;EACpB;;EAEA;IACE,wBAAwB;EAC1B;;EAEA,sBAAsB;AACxB;IACI;MACE,sBAAsB;MACtB,oBAAoB;MACpB,WAAW;IACb;;IAEA;MACE,WAAW;MACX,kBAAkB;MAClB,eAAe;IACjB;;IAEA;MACE,0BAA0B,EAAE,qCAAqC;IACnE;;IAEA;MACE,aAAa;IACf;;IAEA;MACE,eAAe;IACjB;;IAEA;MACE,iBAAiB;IACnB;EACF;;EAEA;IACE;MACE,kBAAkB;MAClB,oBAAoB;IACtB;;IAEA;MACE,kBAAkB;IACpB;;IAEA;MACE,kBAAkB;IACpB;EACF;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,aAAa;IACb,eAAe;IACf,QAAQ;IACR,eAAe;EACjB;;EAEA;IACE,sCAAsC;IACtC,uBAAuB;IACvB,gBAAgB;IAChB,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;EACrB","sourcesContent":["/* Practitioner List Unique Styles */\n.practitioner-list-custom {\n    padding: 2rem;\n}\n\n/* Name Filters should be on the same line */\n.filters-custom {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 1rem;\n    justify-content: space-between;\n}\n\n/* Ensure all name fields appear on the same line */\n.name-fields-custom {\n    display: flex;\n    gap: 1rem;\n    flex-wrap: nowrap;\n    width: 100%; \n}\n\n/* Style the select fields so they appear evenly */\n.name-fields-custom select {\n    flex-grow: 1; \n    padding: 0.75rem;\n    border-radius: var(--radius);\n    border: 1px solid var(--clr-grey-6);\n    font-size: 1rem;\n    color: var(--clr-grey-3);\n    min-width: 150px; \n}\n\n/* Add a responsive adjustment to handle small screen sizes */\n@media (max-width: 768px) {\n    .name-fields-custom {\n        flex-wrap: wrap; \n    }\n\n    .name-fields-custom select {\n        flex-grow: 1;\n        width: 100%; \n    }\n}\n\n/* Practitioners Grid */\n.practitioner-grid-custom {\n    margin-top: 2rem;\n    display: grid;\n    grid-template-columns: repeat(auto-fit, minmax(400px, 1fr)); \n    gap: 1.5rem;\n}\n\n/* Practitioner Card */\n.practitioner-card-custom {\n    background-color: var(--clr-white);\n    padding: 1.5rem;\n    border-radius: var(--radius);\n    box-shadow: var(--light-shadow);\n    transition: var(--transition);\n    min-height: 200px; \n}\n\n.practitioner-card-custom:hover {\n    box-shadow: var(--dark-shadow);\n}\n\n/* Responsive Card Content */\n.card-content-custom h4 {\n    color: var(--clr-primary-5);\n    margin-bottom: 0.5rem;\n}\n\n.card-content-custom p {\n    color: var(--clr-grey-3);\n    margin-bottom: 0.25rem;\n}\n\n.no-practitioner-card-custom {\n    text-align: center;\n    background-color: var(--clr-white);\n    padding: 2rem;\n    border-radius: var(--radius);\n    box-shadow: var(--light-shadow);\n}\n\n/* Pagination Controls */\n.pagination-custom {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    padding: 1rem;\n}\n\n.pagination-custom button {\n    background-color: var(--clr-primary-5);\n    color: var(--clr-white);\n    padding: 0.5rem 1rem;\n    border: none;\n    border-radius: var(--radius);\n    cursor: pointer;\n    margin: 0 0.5rem;\n}\n\n.pagination-custom button:hover {\n    background-color: var(--clr-primary-4);\n    box-shadow: var(--light-shadow);\n}\n\n.pagination-custom button[disabled] {\n    background-color: var(--clr-grey-5);\n    cursor: not-allowed;\n}\n\n/* Responsive Design */\n@media (max-width: 768px) {\n    .practitioner-list-custom {\n        padding: 1rem;\n    }\n\n    .practitioner-grid-custom {\n        grid-template-columns: 1fr; \n    }\n\n    .practitioner-card-custom {\n        padding: 1rem;\n        margin-bottom: 1rem;\n    }\n\n    .card-content-custom h4 {\n        font-size: 1rem;\n    }\n\n    .card-content-custom p {\n        font-size: 0.875rem;\n    }\n\n    .no-practitioner-card-custom {\n        padding: 1.5rem;\n    }\n\n    .filters-custom select {\n        padding: 0.5rem;\n        font-size: 0.875rem;\n    }\n\n    .name-fields-custom {\n        flex-direction: column; \n    }\n}\n\n@media (max-width: 480px) {\n    .practitioner-list-custom {\n        padding: 0.5rem;\n    }\n\n    .practitioner-card-custom {\n        padding: 0.75rem;\n    }\n\n    .card-content-custom h4 {\n        font-size: 0.875rem;\n    }\n\n    .card-content-custom p {\n        font-size: 0.75rem;\n    }\n\n    .no-practitioner-card-custom {\n        padding: 1rem;\n    }\n}\n\n.registered-card {\n    background-color: #e7f9f0; \n    border-left: 5px solid #2e8b57; \n  }\n  \n  .unregistered-card {\n    background-color: #f2f9f6; \n    border-left: 5px solid #a3c9b7; \n  }\n  \n  \n  /* Tabs */\n.tabs-custom {\n    display: flex;\n    gap: 1rem;\n    margin-bottom: 1.5rem;\n  }\n  \n  .tabs-custom button {\n    padding: 0.6rem 1.2rem;\n    background-color: var(--clr-grey-6);\n    color: var(--clr-white);\n    border: none;\n    border-radius: var(--radius);\n    font-weight: 700;\n    cursor: pointer;\n    transition: background-color 0.3s ease;\n    font-size: medium;\n  }\n  \n  .tabs-custom button:hover {\n    background-color: var(--clr-primary-3);\n    color: white;\n  }\n  \n  .tabs-custom .active {\n    background-color: var(--clr-primary-5);\n    color: white;\n  }\n  \n  /* Admin Section Wrapper */\n  .clinic-admins-section {\n    margin-top: 1rem;\n  }\n  \n  /* Grid Layout */\n  .admin-grid-custom {\n    display: grid;\n    grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));\n    gap: 1.5rem;\n    margin-top: 1rem;\n  }\n  \n  /* Base Admin Card */\n  .admin-card-custom {\n    background-color: var(--clr-white);\n    border-radius: var(--radius);\n    box-shadow: var(--shadow-1);\n    padding: 1.5rem;\n    transition: all 0.3s ease;\n    position: relative;\n    border: 1px solid var(--grey-200);\n  }\n  \n  /* Hover effect */\n  .admin-card-custom:hover {\n    box-shadow: var(--shadow-3);\n    transform: translateY(-3px);\n  }\n  \n  /* Clinic Owner: Green border + light green background */\n  .owner-card {\n    border-left: 5px solid #2e7d32; \n    background-color: #e8f5e9;\n  }\n  \n  /* Clinic Admin: Light green background */\n    .admin-card {\n    border-left: 5px solid #2e7d32;\n    background-color: #f1f8f5;\n    }\n\n  \n  /* Card Heading */\n  .admin-card-custom h4 {\n    /* font-size: 1.15rem;\n    font-weight: 600; */\n    color: var(--clr-primary-5);\n    margin-bottom: 0.75rem;\n  }\n  \n  /* Card Text */\n  .admin-card-custom p {\n    margin: 0.4rem 0;\n    color: var(--clr-grey-2);\n    font-size: 0.95rem;\n  }\n  \n  .admin-card-custom p strong {\n    color: var(--clr-grey-1);\n  }\n  \n  /* Responsive styles */\n@media (max-width: 768px) {\n    .tabs-custom {\n      flex-direction: column;\n      align-items: stretch;\n      gap: 0.5rem;\n    }\n  \n    .tabs-custom button {\n      width: 100%;\n      text-align: center;\n      font-size: 1rem;\n    }\n  \n    .admin-grid-custom {\n      grid-template-columns: 1fr; /* Single column on smaller screens */\n    }\n  \n    .admin-card-custom {\n      padding: 1rem;\n    }\n  \n    .admin-card-custom h4 {\n      font-size: 1rem;\n    }\n  \n    .admin-card-custom p {\n      font-size: 0.9rem;\n    }\n  }\n  \n  @media (max-width: 480px) {\n    .tabs-custom button {\n      font-size: 0.95rem;\n      padding: 0.5rem 1rem;\n    }\n  \n    .admin-card-custom h4 {\n      font-size: 0.95rem;\n    }\n  \n    .admin-card-custom p {\n      font-size: 0.85rem;\n    }\n  }\n  \n  .skill-section-custom {\n    margin-top: 0.5rem;\n  }\n  \n  .skill-tag-container {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 6px;\n    margin-top: 4px;\n  }\n  \n  .skill-tag-pill {\n    background-color: var(--clr-primary-5);\n    color: var(--clr-white);\n    padding: 4px 8px;\n    border-radius: 12px;\n    font-size: 0.85rem;\n    font-weight: 500;\n    white-space: nowrap;\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
